export const CONTACT_US_INFO_TYPE: Record<string, common.ContactUsInfo> = {
  Kci2Assure: 'KCI2 Assure',
  AmendmentDisabled: 'Amendment Disabled',
  AlreadyAmended: 'Already Amended',
  ForbidToAmend: 'Forbid To Amend',
  Amendable: 'Amendable',
  Missed: 'Missed',
};
